import "../../design/navbar.css";
import { CiMenuBurger } from "react-icons/ci";
import { IoMdClose } from "react-icons/io";
import React, { useState, useEffect, useRef } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { goToMainPage } from "../../helper/changeLocation";

export default function Navbar() {
    const [showMobile, setShowMobile] = useState(false);
    const [projectsDropdownDesktop, setProjectsDropdownDesktop] = useState(false);
    const [projectsDropdownMobile, setProjectsDropdownMobile] = useState(false);
    const [hideNavbar, setHideNavbar] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();
    const lastScrollY = useRef(0);

    const changeUrlByDivID = (link) => {
        setShowMobile(false);
        if (location.pathname !== "/") {
            navigate("/", { replace: false });
            setTimeout(() => {
                document.getElementById(link)?.scrollIntoView({ behavior: "smooth" });
            }, 100);
        } else {
            document.getElementById(link)?.scrollIntoView({ behavior: "smooth" });
        }
    };

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > lastScrollY.current && window.scrollY > 120) {
                setHideNavbar(true);
            } else {
                setHideNavbar(false);
            }
            lastScrollY.current = window.scrollY;
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <>
            <div className={`navbarWrapper ${hideNavbar ? "hidden" : ""}`}>
                <div className="navbarContainer glass-panel">
                    {/* Brand / Logo */}
                    <div className="navLogo" onClick={goToMainPage()}>
                        <span className="logoAccent">/</span>SYS<span className="logoAccent">.</span>DEV
                    </div>

                    {/* Desktop Navigation */}
                    <div className="navLinks">
                        <span onClick={() => changeUrlByDivID("home")}>System</span>
                        <span onClick={() => changeUrlByDivID("about")}>About</span>
                        <span onClick={() => changeUrlByDivID("services")}>Solutions</span>

                        {/* Dropdown */}
                        <div
                            className="projectsMenu"
                            onMouseEnter={() => setProjectsDropdownDesktop(true)}
                            onMouseLeave={() => setProjectsDropdownDesktop(false)}
                        >
                            <span className="dropdownTrigger">Deployments</span>
                            <div className={`dropdown glass-panel ${projectsDropdownDesktop ? "active" : ""}`}>
                                <span onClick={() => navigate("/templates")}>Templates</span>
                                <span onClick={() => navigate("/live-projects")}>Production</span>
                            </div>
                        </div>

                        <span onClick={() => changeUrlByDivID("pricing")}>Enterprise</span>
                        <span onClick={() => changeUrlByDivID("contact")}>Terminal</span>
                    </div>

                    <div className="mobileMenuBtn" onClick={() => setShowMobile(true)}>
                        <CiMenuBurger size={26} />
                    </div>
                </div>
            </div>

            {/* Mobile Drawer */}
            <div className={`mobileMenu ${showMobile ? "active" : ""}`}>
                <div className="mobileMenuHeader">
                    <IoMdClose size={32} onClick={() => setShowMobile(false)} />
                </div>
                <div className="mobileMenuLinks">
                    <span onClick={() => changeUrlByDivID("home")}>System</span>
                    <span onClick={() => changeUrlByDivID("about")}>About</span>
                    <span onClick={() => changeUrlByDivID("services")}>Solutions</span>

                    <div className="mobileProjectsMenu">
                        <span onClick={() => setProjectsDropdownMobile(!projectsDropdownMobile)}>
                            Deployments
                        </span>
                        {projectsDropdownMobile && (
                            <div className="mobileDropdown">
                                <span onClick={() => { navigate("/templates"); setShowMobile(false); }}>
                                    Templates
                                </span>
                                <span onClick={() => { navigate("/live-projects"); setShowMobile(false); }}>
                                    Production
                                </span>
                            </div>
                        )}
                    </div>

                    <span onClick={() => changeUrlByDivID("pricing")}>Enterprise</span>
                    <span onClick={() => changeUrlByDivID("contact")}>Terminal</span>
                </div>
            </div>

            <Outlet />
        </>
    );
}